/** @param {'agent' | 'persona'} switchKind */
export function buildSelectionSwitchBlock(switchKind, fromLabel, toLabel) {
  return { type: 'selectionSwitch', switchKind, fromLabel, toLabel }
}
